// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"Align_alignLeft__2Yee_","alignRight":"Align_alignRight__3u496","alignCenter":"Align_alignCenter__2Cwn2"};